import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PaiementAmexIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path d="M0 20H24V4H0V20Z" fill="#016FD0" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.414 12.3877V13.3969H15.912V14.0985H18.354V15.1077H15.912V15.7969H18.414V16.8185L20.442 14.6031L18.414 12.3877ZM17.754 8.60923L16.914 6.64615H14.514L12.054 12.3815H14.052V17.4708L20.22 17.4769L21.186 16.3692L22.164 17.4769H24V15.8585L22.848 14.5908L24 13.3292V11.7354L22.842 11.7415V8.67692L21.756 11.7415H20.7L19.584 8.66461V11.7415H17.064L16.704 10.8431H14.724L14.364 11.7415H13.032L14.97 7.26769V7.26153H16.5L18.414 11.6985V7.26153L20.274 7.26769L21.234 10.0185L22.206 7.26153H24V6.64615H21.738L21.228 8.11692L20.718 6.64615H17.754V8.60923ZM14.718 12.3692V16.8431H18.414V16.8369H19.938L21.198 15.4092L22.47 16.8369H24V16.7754L21.996 14.6031L24 12.4V12.3692H22.488L21.228 13.7846L19.98 12.3692H14.718ZM15.138 9.83999L15.714 8.41846L16.296 9.83999H15.138Z"
				fill="white"
			/>
		</svg>
	);
}

PaiementAmexIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PaiementAmexIcon;
